import i18n from "@/i18n";

export const TRANSLATABLE_PAYMENT_STATES = [
  {
    key: "open",
    translation: i18n.t("webshop_payment_state.open")
  },
  {
    key: "canceled",
    translation: i18n.t("webshop_payment_state.canceled")
  },
  {
    key: "pending",
    translation: i18n.t("webshop_payment_state.pending")
  },
  {
    key: "authorized",
    translation: i18n.t("webshop_payment_state.authorized")
  },
  {
    key: "expired",
    translation: i18n.t("webshop_payment_state.expired")
  },
  {
    key: "failed",
    translation: i18n.t("webshop_payment_state.failed")
  },
  {
    key: "paid",
    translation: i18n.t("webshop_payment_state.paid")
  }
];
